import React, { useState } from 'react';
import { FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  const [activeTab, setActiveTab] = useState('contact');

  const contactInfo = [
    {
      icon: <FaPhone className="text-2xl" />,
      title: 'Phone Numbers',
      details: [
        'Emergency: +91 8266958207',
        'Appointments: +91 8266958207',
        'Admin: +91 8266958207',
      ],
      color: 'bg-blue-50 text-blue-700',
    },
    {
      icon: <FaWhatsapp className="text-2xl" />,
      title: 'WhatsApp',
      details: [
        'General Inquiries: +91 8266958207',
        'Service Booking: +91 8266958207',
        'Quick Response within 15 minutes',
      ],
      color: 'bg-green-50 text-green-700',
    },
    {
      icon: <FaEnvelope className="text-2xl" />,
      title: 'Email',
      details: [
        'General: info@leritohealthcare.com',
        'Support: support@leritohealthcare.com',
        'Careers: careers@leritohealthcare.com',
      ],
      color: 'bg-red-50 text-red-700',
    },
    {
      icon: <FaMapMarkerAlt className="text-2xl" />,
      title: 'Location',
      details: [
        'Lerito Health Care & Home Services',
        'Main Road, Near Railway Station',
        'Haridwar, Uttarakhand - 249401',
      ],
      color: 'bg-purple-50 text-purple-700',
    },
    {
      icon: <FaClock className="text-2xl" />,
      title: 'Working Hours',
      details: [
        'Emergency Services: 24/7',
        'Office Hours: 8 AM - 8 PM',
        'Home Visits: 9 AM - 7 PM',
      ],
      color: 'bg-orange-50 text-orange-700',
    },
  ];

  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-poppins">
            Contact Us
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get in touch with our healthcare team for appointments, inquiries, or emergency assistance
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - Contact Information */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 font-poppins">
                Contact Information
              </h2>
              
              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className={`p-6 rounded-xl ${info.color}`}>
                    <div className="flex items-center space-x-4 mb-3">
                      <div className="p-3 bg-white rounded-full shadow">
                        {info.icon}
                      </div>
                      <h3 className="text-lg font-bold">{info.title}</h3>
                    </div>
                    <div className="space-y-2">
                      {info.details.map((detail, idx) => (
                        <p key={idx} className="text-sm">{detail}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* Emergency Contact Card */}
              <div className="mt-8 bg-gradient-to-r from-red-500 to-orange-500 rounded-xl p-6 text-white">
                <h3 className="text-xl font-bold mb-4">🚨 Emergency Contact</h3>
                <p className="mb-2">For medical emergencies, call immediately:</p>
                <a
                  href="tel:+918266958207"
                  className="text-2xl font-bold block mb-4 hover:underline"
                >
                  +91 8266958207
                </a>
                <p className="text-sm opacity-90">
                  Available 24/7 • Ambulance Dispatch • Immediate Assistance
                </p>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form & Map */}
          <div className="lg:col-span-2">
            {/* Tabs */}
            <div className="flex mb-6 border-b">
              <button
                className={`flex-1 py-4 text-center font-semibold ${activeTab === 'contact' ? 'text-health-blue border-b-2 border-health-blue' : 'text-gray-500'}`}
                onClick={() => setActiveTab('contact')}
              >
                Send Message
              </button>
              <button
                className={`flex-1 py-4 text-center font-semibold ${activeTab === 'appointment' ? 'text-health-blue border-b-2 border-health-blue' : 'text-gray-500'}`}
                onClick={() => setActiveTab('appointment')}
              >
                Book Appointment
              </button>
              <button
                className={`flex-1 py-4 text-center font-semibold ${activeTab === 'feedback' ? 'text-health-blue border-b-2 border-health-blue' : 'text-gray-500'}`}
                onClick={() => setActiveTab('feedback')}
              >
                Feedback
              </button>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <ContactForm formType={activeTab} />
            </div>

            {/* Map Section */}
            <div className="mt-8 bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4 font-poppins">
                  Our Location in Haridwar
                </h3>
                <div className="h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                  {/* Google Maps Integration */}
                  <div className="text-center">
                    <FaMapMarkerAlt className="text-4xl text-red-500 mx-auto mb-4" />
                    <p className="text-gray-600">Google Maps Integration</p>
                    <p className="text-sm text-gray-500 mt-2">
                      Main Road, Near Railway Station, Haridwar
                    </p>
                    <a
                      href="https://maps.google.com/?q=Lerito+Health+Care+Haridwar"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block mt-4 px-6 py-2 bg-health-blue text-white rounded-full hover:bg-blue-700 transition-colors"
                    >
                      Open in Google Maps
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;